// Inside your component (e.g. VideoNotes.jsx)
import React from "react";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";

import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";

const VideoNotes = () => {
  const { id } = useParams();

  const [Teacher, setTeacher] = useState(null);
  const [Video, setVideo] = useState(null);
  const [Notes, setNotes] = useState(null);

  const [loading, setLoading] = useState(true);
  //fetch teacher All Video according id

  // ENCRYPTION VIDEO LINK
  const secretKey = "sachin";
  const encryptFilename = (filename) => {
    return CryptoJS.AES.encrypt(filename, secretKey).toString();
  };
  const decryptFilename = (cipherText) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  useEffect(() => {
    axios
      //   .get(`https://topfaculty.co.in/api/video_fetch.php?TeacherId=${id}`)
      .get(`https://viasacademy.com/viasapi/vedioapi.php`)
      .then((response) => {
        console.log(response.data);
        setVideo(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error Fetching Video Data", error);
        setLoading(false);
      });
  }, [id]);

  //NOTES
  // useEffect(() => {
  //   axios
  //     .get(`https://viasacademy.com/viasapi/hindinotes.php`)
  //     .then((response2) => {
  //       console.log(response2.data);
  //       setNotes(response2.data);
  //     })
  //     .catch((error) => {
  //       console.log("Error Fetching Video Data", error);
  //     });
  // }, [id]);

  useEffect(() => {
    // Wait until table data is rendered
    if (Video && Video.length > 0) {
      // Prevent multiple initializations
      if ($.fn.DataTable.isDataTable("#example")) {
        $("#example").DataTable().destroy(); // destroy previous instance
      }

      setTimeout(() => {
        $("#example").DataTable(); // initialize again
      }, 100); // small delay to ensure table is rendered
    }
  }, [Video]);

  return (
    <>
      {/* VIDEO SECTION */}
      <div
        id="rs-latest-news-style7"
        className="rs-latest-news-style7 sec-spacer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rs-latest-list">
                <div className="latest-wrap">
                  <div className="shipping-area">
                    <div className="container">
                      <div className="tab-content">
                        <div className="tab-pane active" id="checkout">
                          <div className="row">
                            <h2 className="title pb-40 md-pb-30 uppercase">
                              Videos
                            </h2>
                            <div className="table-responsive">
                              <table
                                id="example"
                                className="table table-striped table-bordered"
                                style={{
                                  width: "100%",
                                  boxShadow:
                                    "inset rgba(0, 0, 0, 0.35) 1px -rgb(166 166 166 / 35%) 4px -1px 3px -5px inset 14px 0px",
                                }}
                              >
                                <thead
                                  style={{
                                    color: "black",
                                    background: "#f7b205",
                                  }}
                                >
                                  <tr>
                                    <th>Sr No.</th>
                                    <th>Topic</th>
                                    <th>View Video </th>
                                    <th>Uploaded Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loading ? (
                                    <tr>
                                      <td
                                        colSpan={7}
                                        style={{ textAlign: "center" }}
                                      >
                                        <span
                                          style={{
                                            fontWeight: "bold",
                                            color: "#002347",
                                            fontSize: "30px",
                                          }}
                                        >
                                          Please wait
                                          <span className="dot-loader">
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                          </span>
                                        </span>
                                      </td>
                                    </tr>
                                  ) : Video && Video.length > 0 ? (
                                    Video.map((video, index) => (
                                      <tr key={index}>
                                        <td>
                                          <p
                                            style={{
                                              color: "black",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {index + 1}
                                          </p>
                                        </td>
                                        <td style={{ width: "30%" }}>
                                          {(() => {
                                            const encrypted = encryptFilename(
                                              video.VideoFilename
                                            );
                                            return (
                                              <Link
                                                to={`/runningvideo/${encodeURIComponent(
                                                  encrypted
                                                )}/${encodeURIComponent(
                                                  video.VideoName
                                                )}`}
                                              >
                                                <h6
                                                  style={{
                                                    color: "blue",
                                                    fontWeight: "700",
                                                    fontSize: "18px",
                                                  }}
                                                >
                                                  {video.VideoName}
                                                </h6>
                                              </Link>
                                            );
                                          })()}
                                        </td>
                                        <td>
                                          <p>{video.CreatedDate}</p>
                                        </td>
                                        <td>
                                          <strong>
                                            {/* <Link
                                                to={`/runningvideo/${encodeURIComponent(encrypted)}/${encodeURIComponent(video.VideoName)}`}
                                              >
                                              <i
                                                className="fa fa-video-camera"
                                                style={{
                                                  fontSize: "25px",
                                                  color: "#05a105",
                                                }}
                                                aria-hidden="true"
                                              ></i>
                                            </Link> */}

                                            {(() => {
                                              const encrypted = encryptFilename(
                                                video.VideoFilename
                                              );
                                              return (
                                                <Link
                                                  to={`/runningvideo/${encodeURIComponent(
                                                    encrypted
                                                  )}/${encodeURIComponent(
                                                    video.VideoName
                                                  )}`}
                                                >
                                                  <i
                                                    className="fa fa-video-camera"
                                                    style={{
                                                      fontSize: "25px",
                                                      color: "#05a105",
                                                    }}
                                                    aria-hidden="true"
                                                  ></i>
                                                </Link>
                                              );
                                            })()}
                                          </strong>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={7}>
                                        <p style={{ textAlign: "center" }}>
                                          No video available
                                        </p>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* NOTES SECTION */}
      {/* <div
        id="rs-latest-news-style7"
        className="rs-latest-news-style7 sec-spacer"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rs-latest-list">
                <div className="latest-wrap">
                  <div className="shipping-area">
                    <div className="container">
                      <div className="tab-content">
                        <div className="tab-pane active" id="checkout">
                          <div className="row">
                            <h2 className="title pb-40 md-pb-30 uppercase">
                              Notes
                            </h2>
                            <div className="table-responsive">
                              <table
                                id="example"
                                className="table table-striped table-bordered"
                                style={{
                                  width: "100%",
                                  boxShadow:
                                    "inset rgba(0, 0, 0, 0.35) 1px -rgb(166 166 166 / 35%) 4px -1px 3px -5px inset 14px 0px",
                                }}
                              >
                                <thead
                                  style={{
                                    color: "black",
                                    background: "#f7b205",
                                  }}
                                >
                                  <tr>
                                    <th>Sr No.</th>
                                    <th>Topic</th>
                                    <th>Read Notes</th>
                                    <th>Uploaded Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Notes && Notes.length > 0 ? (
                                    Notes.map((Notes, index) => (
                                      <tr>
                                        <td style={{ width: "13%" }}>
                                          <p
                                            style={{
                                              color: "black",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {index+1}
                                          </p>
                                        </td>
                                        <td>
                                          <h6
                                            style={{
                                              color: "blue",
                                              fontWeight: "700",
                                              fontSize: "18px",
                                            }}
                                          >
                                            {Notes.name}
                                          </h6>
                                        </td>

                                        <td>
                                          <p>{Notes.createdate}</p>
                                        </td>

                                        <td>
                                          <span className="prize">
                                            <a
                                              href={Notes.filename}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <i
                                                className="fa fa-file-pdf-o"
                                                style={{
                                                  fontSize: "25px",
                                                  color: "red",
                                                }}
                                                aria-hidden="true"
                                              ></i>
                                            </a>
                                          </span>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={7}>
                                        <p style={{ textAlign: "center" }}>
                                          No video available
                                        </p>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default VideoNotes;
